import React from "react";
import DetailsModal from "../pages/admin-concursos/DetailsModal";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import GetAppIcon from "@material-ui/icons/GetApp";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import DescriptionIcon from "@material-ui/icons/Description";
import ActaFinalModal from "../pages/concursos/ActaFinalModal";
import {makeStyles} from "@material-ui/core/styles";
import axios from "axios";

const useStyles = makeStyles({
    menuIcon: {
        minWidth: "35px",
    },
    tooltip: {
        fontSize: "14px",
        fontWeight: "normal",
    },
    item: {
        "& .MuiTreeItem-iconContainer svg": { fontSize: "24px" },
        "& .MuiTreeItem-label": { fontSize: "24px" },
        "&.Mui-selected .MuiTreeItem-label": { background: "none !important" },
    },
});

const ExcelIcon = () => {
    return (
        <img
            style={{ opacity: 0.54 }}
            alt=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAABDklEQVRIie3VsS4FQRQG4G8v0ap5BJWg5BU8hF6hIl7Bk6gkEtFJUNCIRkGodKJSSRRWcedek8nsjt2N7v7JSeZkzjn/mfPPzjJDAVVhfxnrwdbwgMO+BIvYigpuYCmJrzHqQhDjORQoWUzWZNe5E8TJbZjklOIrBhw3FKhafE0Er9jBR/APcDugkSkm87sP/hEuw/pMNw2mcU0abOMRK3jDTbTXSYPcCWrchYARLnKdZfKyfpPIX35F+yx02orciGpsYg4LeDfWZZTk9B7RSfBPcR7Wx3qKnCO4wi6+g+0ZX9NeGgz5ktO8dHQVzP+xaA5pQ9kG41v0MoAsRfax+5fnussPZxVP2O9CMEMRP3BaZwUittzdAAAAAElFTkSuQmCC"
        />
    );
};

const ZipIcon = () => {
    return (
        <img
            style={{ opacity: 0.54 }}
            alt=""
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAt0lEQVRIie2UwQnCQBBFX8QGrCG2EcSbehZbSBs2pLWICN5EtAG9eokHxyDLujsjI3rIh09YMvPffgiBTv+kGXAGmoiXHoB34W6QVLjFB2D8TUADHJ+hRQBIqQjOqvl+ZsgSGJUFYG1gBnzUoKec2/Fo8Oq9J2Alz6EYYK3cbZX67CoJvolLYJTZMTXYBhcB2Hg2mMtMKQZYaBpoARegBgbiGrhaAbmfncWnGGAqLzzCJzFAp9/oDka7lylRLwaRAAAAAElFTkSuQmCC"
        />
    );
};

const downloadActa = (concursoId) => {
    axios({
        url: (window as any).ENV.API_URL + "/downloadFile/a" + concursoId + "/",
        method: "GET",
        responseType: "blob", // important
    })
        .then((response) => {
            const file = new Blob([response.data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.download = "ActaFinal";
            link.click();
        })
        .catch((error) => console.error(error));
};

const downloadFiles = (concursoId, concursoCode) => {
    axios({
        url: (window as any).ENV.API_URL + "/archivosPostulantes/" + concursoId,
        method: "GET",
        responseType: "blob", // important
    })
        .then((response) => {
            const file = new Blob([response.data], { type: "application/zip" });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.download = concursoCode;
            link.click();
        })
        .catch((error) => console.error(error));
};

const downloadPostulantes = (concursoId, concursoCode) => {
    axios({
        url: (window as any).ENV.API_URL + "/reporteConcurso/" + concursoId,
        method: "GET",
        responseType: "blob", // important
    })
        .then((response) => {
            const file = new Blob([response.data], {
                type: "application/vnd.ms-excel",
            });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.download = "Postulantes" + concursoCode + ".xlsx";
            link.click();
        })
        .catch((error) => console.error(error));
};


export const ActionsButtons = (props) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    console.log(props.pending)

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div className="d-flex justify-content-around">
            <DetailsModal
                label="Detalles"
                concursoId={props.concursoId}
                facultades={props.facultades}
            />
            <div>
                <Tooltip
                    onClick={handleClick}
                    title={<span className={classes.tooltip}>Descargar</span>}
                >
                    <IconButton>
                        <GetAppIcon />
                    </IconButton>
                </Tooltip>
                {/*
        <Button startIcon={<GetAppIcon />} onClick={handleClick}>
          Postulaciones
        </Button>*/}

                <Menu
                    getContentAnchorEl={null}
                    anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "center",
                    }}
                    transformOrigin={{
                        vertical: "top",
                        horizontal: "center",
                    }}
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    style={{ border: "1px solid #ccc" }}
                >
                    <MenuItem
                        onClick={() => downloadPostulantes(props.concursoId, props.codigo)}
                    >
                        <ListItemIcon className={classes.menuIcon}>
                            <ExcelIcon />
                        </ListItemIcon>
                        <ListItemText primary="Datos Postulantes (Excel)" />
                    </MenuItem>
                    <MenuItem
                        onClick={() => downloadFiles(props.concursoId, props.codigo)}
                    >
                        <ListItemIcon className={classes.menuIcon}>
                            <ZipIcon />
                        </ListItemIcon>
                        <ListItemText primary="Documentos Postulantes" />
                    </MenuItem>
                    {!props.pending && !props.abierto ? (
                        <MenuItem onClick={() => downloadActa(props.concursoId)}>
                            <ListItemIcon className={classes.menuIcon}>
                                <DescriptionIcon />
                            </ListItemIcon>
                            <ListItemText primary="Acta de cierre" />
                        </MenuItem>
                    ) : null}
                </Menu>
            </div>
            {props.pending ? (
                <ActaFinalModal
                    label="Acta de cierre"
                    concursoId={props.concursoId}
                    code={props.codigo}
                    name={props.nombre}
                />
            ) : null}
        </div>
    );
};
